module.exports = __webpack_public_path__ + "static/media/varie5.7a97e5d3.jpg";